import { MprolabContract, ConfigUpdateData } from '@mprolab/sdk'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type ConfigDataQP = Pick<ConfigUpdateData, 'configKey'>

export const configApi = createApi({
  reducerPath: 'config',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/config' }),
  endpoints: (builder) => ({
    getContracts: builder.query<MprolabContract[], undefined>({
      query: () => {
        return {
          url: 'contracts',
          method: 'GET',
        }
      }
    }),
    getAllConfigUpdateData: builder.query<ConfigUpdateData[], undefined>({
      query: () => {
        return {
          url: 'updates',
          method: 'GET',
        }
      }
    }),
    getConfigUpdateData: builder.query<ConfigUpdateData, ConfigDataQP>({
      query: ({ configKey }) => {
        return {
          url: `updates/${configKey}`,
          method: 'GET',
        }
      }
    })
  })
})

export const {
  useGetContractsQuery,
  useLazyGetContractsQuery,
  useGetAllConfigUpdateDataQuery,
  useLazyGetAllConfigUpdateDataQuery,
  useGetConfigUpdateDataQuery,
  useLazyGetConfigUpdateDataQuery
} = configApi
